/**
 * 中间层 JSON Schema 校验（生成前）。使用精简 schema.json + ajv。
 * 输出带 JSON Path 的中文错误信息，便于 AI 直接定位问题。
 */

import { Ajv } from 'ajv';
import addFormats from 'ajv-formats';
import schema from '../ir/schema.json' with { type: 'json' };
import type { ReportIR } from '../ir/types.js';

export interface ValidationError {
  path: string;
  message: string;
}

export class IRValidationError extends Error {
  constructor(public errors: ValidationError[]) {
    super('报表中间层校验失败：\n' + errors.map((e) => `  - ${e.path}: ${e.message}`).join('\n'));
    this.name = 'IRValidationError';
  }
}

const ajv = new Ajv({ allErrors: true, verbose: true, strict: false });
(addFormats as any)(ajv);
const validate = ajv.compile(schema);

/** 校验中间层。通过返回 void；失败抛 IRValidationError。 */
export function validateIR(ir: unknown): ReportIR {
  const ok = validate(ir);
  if (ok) return ir as unknown as ReportIR;
  const errors: ValidationError[] = (validate.errors ?? []).map((e) => ({
    path: e.instancePath || '/',
    message: e.message ?? '未知错误',
  }));
  throw new IRValidationError(errors);
}
